module.exports = __webpack_public_path__ + "static/responsive-bb9ce36bf05dce891698646090d2187e.svg";